import React, { useState, useEffect } from 'react';
import './NewNotificationBar.css';
import notificationsService from '../services/notificationsService';

const NewNotificationBar = ({ isVisible, onClose }) => {
  // Temporary mock data for testing
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      title: "سيتم الاعلان عن الجوائز اليوم 5.10 على الساعة 20:00",
      message: "prizes",
      emoji: "🏆"
    }
  ]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isVisible) {
      fetchNotifications();
    }
  }, [isVisible]);

  const fetchNotifications = async () => {
    try {
      console.log('🔔 NewNotificationBar: Starting to fetch notifications...');
      setLoading(true);
      setError(null);
      
      const activeNotifications = await notificationsService.getActiveNotifications();
      console.log('🔔 NewNotificationBar: Received notifications:', activeNotifications);
      
      // Show only the most recent/important notification in the bar
      const notificationToShow = activeNotifications.slice(0, 1);
      console.log('🔔 NewNotificationBar: Notification to show:', notificationToShow);
      
      setNotifications(notificationToShow);
      
    } catch (err) {
      console.error('❌ NewNotificationBar: Failed to fetch notifications:', err);
      setError('Failed to load notifications');
    } finally {
      setLoading(false);
    }
  };


  console.log('🔔 NewNotificationBar: isVisible =', isVisible, 'notifications.length =', notifications.length);
  
  if (!isVisible || notifications.length === 0) {
    console.log('🔔 NewNotificationBar: Not rendering (isVisible:', isVisible, 'notifications:', notifications.length, ')');
    return null;
  }

  const notification = notifications[0];

  return (
    <div className="new-notification-bar">
      <div className="notification-content">
        <div className="notification-text-section">
          <div className="notification-emoji">
            {notification.emoji}
          </div>
            <div className="notification-text">
                  <div className="notification-title">
                    {notification.title}
                  </div>
                </div>
        </div>

      </div>
    </div>
  );
};

export default NewNotificationBar;
